<script lang="ts">
  /** Horizontal client picker — the first tap of the two-tap logging path. */
  import { store } from '$lib/store.svelte';

  const visible = $derived(store.clients.filter((c) => !c.archived));
</script>

{#if visible.length}
  <div class="chips" role="tablist" aria-label="Clients">
    {#each visible as client (client.id)}
      <button
        role="tab"
        aria-selected={client.id === store.activeClientId}
        class:active={client.id === store.activeClientId}
        style="--chip: {client.color}"
        onclick={() => store.selectClient(client.id)}
      >
        <span class="dot" aria-hidden="true"></span>
        {client.name}
      </button>
    {/each}
  </div>
{/if}

<style>
  .chips {
    display: flex;
    gap: 0.45rem;
    overflow-x: auto;
    padding-bottom: 0.25rem;
    scrollbar-width: none;
  }

  .chips::-webkit-scrollbar {
    display: none;
  }

  button {
    display: inline-flex;
    align-items: center;
    gap: 0.45rem;
    white-space: nowrap;
    min-height: 40px;
    padding: 0.4rem 0.85rem;
    border-radius: 999px;
    background: var(--surface);
    font-size: 0.92rem;
  }

  button.active {
    border-color: var(--chip);
    background: color-mix(in srgb, var(--chip) 16%, var(--surface));
    font-weight: 650;
  }

  .dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--chip);
    flex: none;
  }
</style>
